module.exports = __webpack_public_path__ + "img/quotation-marks.54a70229.png";